"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectSpread"));

var _react = _interopRequireDefault(require("react"));

var _reactMarkdown = _interopRequireDefault(require("react-markdown"));

var _mathjax = _interopRequireDefault(require("@nteract/mathjax"));

var _remarkMath = _interopRequireDefault(require("./remark-math"));

var math = function math(props) {
  return _react["default"].createElement(_mathjax["default"].Node, null, props.value);
};

var inlineMath = function inlineMath(props) {
  return _react["default"].createElement(_mathjax["default"].Node, {
    inline: true
  }, props.value);
};

var MarkdownRender = function MarkdownRender(props) {
  var newProps = (0, _objectSpread2["default"])({}, props, {
    escapeHtml: false,
    plugins: [_remarkMath["default"]],
    renderers: (0, _objectSpread2["default"])({}, props.renderers, {
      math: math,
      inlineMath: inlineMath
    })
  });
  return _react["default"].createElement(_reactMarkdown["default"], newProps);
};

var _default = MarkdownRender;
exports["default"] = _default;